module.exports = __webpack_public_path__ + "static/media/large-leather-1920x1080.2427a8e6.png";